export const sortRows = (rows: any[], descending: boolean, sortBy: string) =>
  [...rows].sort((a, b) => {
    if (a.isNew && !b.isNew) return -1;
    if (!a.isNew && b.isNew) return 1;

    const valA = a[sortBy];
    const valB = b[sortBy];

    if (valA === valB) return 0;
    return (valA > valB ? 1 : -1) * (descending ? -1 : 1);
  });

export const sliceRows = (rows: any[], page: number, itemsPerPage: number) =>
  rows.slice(itemsPerPage * (page - 1), itemsPerPage * page);
